/**
 * Role constants that mirror the backend Roles class
 * Source: Domain/Constants/Roles.cs
 *
 * Note: Only 'Administrator' is currently defined in the backend.
 * Other roles are defined here for UI consistency and future backend implementation.
 */
export const Roles = {
  // Backend-defined roles
  Administrator: 'Administrator',

  // Frontend-defined roles (to be added to backend)
  SystemOwner: 'SystemOwner',
  HRMaster: 'HRMaster',
  ITSupport: 'ITSupport',
  DepartmentAdmin: 'DepartmentAdmin',
  Superior: 'Superior',
  Approver: 'Approver',
  PIC: 'PIC',
  Employee: 'Employee',
} as const;

export type RoleName = typeof Roles[keyof typeof Roles];
